import DigitalAssetkActionTypes from './digitalAssets-types'

const INITIAL_STATE = {
    digitalAssetWallets: null,
    availableDigitalAssets: null,
    digitalAssetWalletBelongsInSystem: null,
    loader: null,
    success: null,
    error: null,
    errors: null,
    estimatedFee: null,
    keys: null,
    payslipData: null,
    digitalAssetBeneficiaries: null,
    digitalAssetWallet: null,
}

const digitalAsseReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case DigitalAssetkActionTypes.SUCCESS_FETCH_AVAILABLE_DIGITAL_ASSETS:
            return {
                ...state,
                availableDigitalAssets: action.payload,
            }
        case DigitalAssetkActionTypes.START_ADD_DIGITAL_ASSET:
            return {
                ...state,
                loader: { ...state.loader, ADD_DIGITAL_ASSET: true },
            }
        case DigitalAssetkActionTypes.SUCCESS_ADD_DIGITAL_ASSET:
            return {
                ...state,
                success: { ...state.success, ADD_DIGITAL_ASSET: true },
            }
        case DigitalAssetkActionTypes.FINISH_ADD_DIGITAL_ASSET:
            return {
                ...state,
                success: { ...state.success, ADD_DIGITAL_ASSET: null },
            }
        case DigitalAssetkActionTypes.COMPLETE_REQUEST_ADD_DIGITAL_ASSET:
            return {
                ...state,
                loader: { ...state.loader, ADD_DIGITAL_ASSET: null },
            }
        case DigitalAssetkActionTypes.FAILURE_ADD_DIGITAL_ASSET:
            return {
                ...state,
                loader: { ...state.loader, ADD_DIGITAL_ASSET: null },
                success: { ...state.success, ADD_DIGITAL_ASSET: null },
            }
        case DigitalAssetkActionTypes.START_SEND_DIGITAL_ASSETS_AMOUNT:
            return {
                ...state,
                loader: { ...state.loader, SEND_DIGITAL_ASSETS_AMOUNT: true },
            }
        case DigitalAssetkActionTypes.SUCCESS_SEND_DIGITAL_ASSETS_AMOUNT:
            return {
                ...state,
                loader: { ...state.loader, SEND_DIGITAL_ASSETS_AMOUNT: null },
                success: { ...state.success, SEND_DIGITAL_ASSETS_AMOUNT: true },
                error: null,
            }
        case DigitalAssetkActionTypes.FINISH_SEND_DIGITAL_ASSETS_AMOUNT:
            return {
                ...state,
                loader: { ...state.loader, SEND_DIGITAL_ASSETS_AMOUNT: null },
                success: { ...state.success, SEND_DIGITAL_ASSETS_AMOUNT: null },
                error: null,
            }
        case DigitalAssetkActionTypes.FAILURE_SEND_DIGITAL_ASSETS_AMOUNT:
            return {
                ...state,
                loader: { ...state.loader, SEND_DIGITAL_ASSETS_AMOUNT: null },
                success: { ...state.success, SEND_DIGITAL_ASSETS_AMOUNT: null },
                error: true,
            }

        case DigitalAssetkActionTypes.START_BUY_USDC_COIN:
            return {
                ...state,
                loader: { ...state.loader, BUY_USDC_COIN: true },
            }
        case DigitalAssetkActionTypes.SUCCESS_BUY_USDC_COIN:
            return {
                ...state,
                loader: { ...state.loader, BUY_USDC_COIN: null },
                success: { ...state.success, BUY_USDC_COIN: true },
                error: null,
            }
        case DigitalAssetkActionTypes.FINISH_BUY_USDC_COIN:
            return {
                ...state,
                loader: { ...state.loader, BUY_USDC_COIN: null },
                success: { ...state.success, BUY_USDC_COIN: null },
                error: null,
            }
        case DigitalAssetkActionTypes.FAILURE_BUY_USDC_COIN:
            return {
                ...state,
                loader: { ...state.loader, BUY_USDC_COIN: null },
                success: { ...state.success, BUY_USDC_COIN: null },
                error: true,
            }

        case DigitalAssetkActionTypes.START_BUY_USDC_COIN_WITH_BANK:
            return {
                ...state,
                loader: { ...state.loader, BUY_USDC_COIN_WITH_BANK: true },
            }
        case DigitalAssetkActionTypes.SUCCESS_BUY_USDC_COIN_WITH_BANK:
            return {
                ...state,
                loader: { ...state.loader, BUY_USDC_COIN_WITH_BANK: null },
                success: { ...state.success, BUY_USDC_COIN_WITH_BANK: true },
                payslipData: action.payload,
                error: null,
            }
        case DigitalAssetkActionTypes.FINISH_BUY_USDC_COIN_WITH_BANK:
            return {
                ...state,
                loader: { ...state.loader, BUY_USDC_COIN_WITH_BANK: null },
                success: { ...state.success, BUY_USDC_COIN_WITH_BANK: null },
                error: null,
                payslipData: null,
            }
        case DigitalAssetkActionTypes.FAILURE_BUY_USDC_COIN_WITH_BANK:
            return {
                ...state,
                loader: { ...state.loader, BUY_USDC_COIN_WITH_BANK: null },
                success: { ...state.success, BUY_USDC_COIN_WITH_BANK: null },
                error: true,
            }

        case DigitalAssetkActionTypes.START_TRANSFER_USDC_COIN:
            return {
                ...state,
                loader: { ...state.loader, TRANSFER_USDC_COIN: true },
            }
        case DigitalAssetkActionTypes.SUCCESS_TRANSFER_USDC_COIN:
            return {
                ...state,
                loader: { ...state.loader, TRANSFER_USDC_COIN: null },
                success: { ...state.success, TRANSFER_USDC_COIN: true },
                error: null,
            }
        case DigitalAssetkActionTypes.FINISH_TRANSFER_USDC_COIN:
            return {
                ...state,
                loader: { ...state.loader, TRANSFER_USDC_COIN: null },
                success: { ...state.success, TRANSFER_USDC_COIN: null },
                error: null,
            }
        case DigitalAssetkActionTypes.FAILURE_TRANSFER_USDC_COIN:
            return {
                ...state,
                loader: { ...state.loader, TRANSFER_USDC_COIN: null },
                success: { ...state.success, TRANSFER_USDC_COIN: null },
                error: true,
            }

        case DigitalAssetkActionTypes.START_SEND_USDC_COIN:
            return {
                ...state,
                loader: { ...state.loader, SEND_USDC_COIN: true },
            }
        case DigitalAssetkActionTypes.SUCCESS_SEND_USDC_COIN:
            return {
                ...state,
                loader: { ...state.loader, SEND_USDC_COIN: null },
                success: { ...state.success, SEND_USDC_COIN: true },
                error: null,
            }
        case DigitalAssetkActionTypes.FINISH_SEND_USDC_COIN:
            return {
                ...state,
                loader: { ...state.loader, SEND_USDC_COIN: null },
                success: { ...state.success, SEND_USDC_COIN: null },
                error: null,
            }
        case DigitalAssetkActionTypes.FAILURE_SEND_USDC_COIN:
            return {
                ...state,
                loader: { ...state.loader, SEND_USDC_COIN: null },
                success: { ...state.success, SEND_USDC_COIN: null },
                error: true,
            }

        case DigitalAssetkActionTypes.START_GET_DIGITAL_ASSET_WALLET_BY_ID:
            return {
                ...state,
                loader: { ...state.loader, GET_DIGITAL_ASSET_WALLET_BY_ID: true },
                errors: { ...state.errors, GET_DIGITAL_ASSET_WALLET_BY_ID: null },
            }
        case DigitalAssetkActionTypes.SUCCESS_GET_DIGITAL_ASSET_WALLET_BY_ID:
            return {
                ...state,
                digitalAssetWallet: action.payload,
                loader: { ...state.loader, GET_DIGITAL_ASSET_WALLET_BY_ID: null },
                success: { ...state.success, GET_DIGITAL_ASSET_WALLET_BY_ID: true },
            }
        case DigitalAssetkActionTypes.FINISH_GET_DIGITAL_ASSET_WALLET_BY_ID:
            return {
                ...state,
                digitalAssetWallet: null,
                loader: { ...state.loader, GET_DIGITAL_ASSET_WALLET_BY_ID: null },
                success: { ...state.success, GET_DIGITAL_ASSET_WALLET_BY_ID: null },
                errors: { ...state.errors, GET_DIGITAL_ASSET_WALLET_BY_ID: null },
            }
        case DigitalAssetkActionTypes.FAILURE_GET_DIGITAL_ASSET_WALLET_BY_ID:
            return {
                ...state,
                digitalAssetWallet: null,
                loader: { ...state.loader, GET_DIGITAL_ASSET_WALLET_BY_ID: null },
                success: { ...state.success, GET_DIGITAL_ASSET_WALLET_BY_ID: null },
                errors: { ...state.errors, GET_DIGITAL_ASSET_WALLET_BY_ID: true },
            }

        case DigitalAssetkActionTypes.SUCCESS_RECEIVE_DIGITAL_ASSET_BENEFICIARIES:
            return {
                ...state,
                digitalAssetBeneficiaries: action.payload,
            }
        case DigitalAssetkActionTypes.SUCCESS_GET_ENCRYPTION_KEY:
            return {
                ...state,
                keys: action.payload,
            }

        case DigitalAssetkActionTypes.START_GET_DIGITAL_ASSET_WALLET_ADDRESS_TYPE:
            return {
                ...state,
                loader: { ...state.loader, GET_DIGITAL_ASSET_WALLET_ADDRESS_TYPE: true },
                errors: { ...state.errors, GET_DIGITAL_ASSET_WALLET_ADDRESS_TYPE: null },
            }
        case DigitalAssetkActionTypes.SUCCESS_GET_DIGITAL_ASSET_WALLET_ADDRESS_TYPE:
            return {
                ...state,
                digitalAssetWalletBelongsInSystem: action.payload,
                loader: { ...state.loader, GET_DIGITAL_ASSET_WALLET_ADDRESS_TYPE: null },
                success: { ...state.success, GET_DIGITAL_ASSET_WALLET_ADDRESS_TYPE: true },
            }
        case DigitalAssetkActionTypes.FINISH_GET_DIGITAL_ASSET_WALLET_ADDRESS_TYPE:
            return {
                ...state,
                digitalAssetWalletBelongsInSystem: null,
                loader: { ...state.loader, GET_DIGITAL_ASSET_WALLET_ADDRESS_TYPE: null },
                success: { ...state.success, GET_DIGITAL_ASSET_WALLET_ADDRESS_TYPE: null },
                errors: { ...state.errors, GET_DIGITAL_ASSET_WALLET_ADDRESS_TYPE: null },
            }
        case DigitalAssetkActionTypes.FAILURE_GET_DIGITAL_ASSET_WALLET_ADDRESS_TYPE:
            return {
                ...state,
                digitalAssetWalletBelongsInSystem: null,
                loader: { ...state.loader, GET_DIGITAL_ASSET_WALLET_ADDRESS_TYPE: null },
                success: { ...state.success, GET_DIGITAL_ASSET_WALLET_ADDRESS_TYPE: null },
                errors: { ...state.errors, GET_DIGITAL_ASSET_WALLET_ADDRESS_TYPE: true },
            }

        default:
            return state
    }
}

export default digitalAsseReducer
